import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import { userMetadataResponseSchema } from '../../../common/validations'

import { get } from 'api/apiClient'

const params = {
  queryKey: [API_ENDPOINTS.USER_METADATA],
  queryFn: () => get(API_ENDPOINTS.USER_METADATA, userMetadataResponseSchema),
}

export const useAPIGetUserMetadata = () => useQuery(params)

export const useAPIGetUserMetadataSuspense = () => useSuspenseQuery(params)
